<template>
  <div
    :id="`${id}_wrap`"
    ref="fileUploadComponent"
    class="filedupload-wrap">
    <div
      class="fileupload-input-line"
      :class="error ? 'validation-error' : ''">
      <div class="fileupload-input">
        <button
          v-if="localThumbImage"
          class="fileupload-image-button"
          @click.prevent="onImageClick()"
          aria-label="Open image in a dialog">
          <img
            class="fileupload-image"
            :src="localThumbImage"
            :alt="localBlobFileName" />
        </button>
        <span class="fileupload-link">
          <input
            :name="`${name}` + 'filechanged'"
            :id="`${name}` + 'filechanged'"
            style="display: none"
            v-model="wasDeleted" />
          <input
            :name="`${name}`"
            :id="`${name}`"
            type="file"
            style="display: none"
            :data-rule-required="required && !localBlobFileName"
            ref="fileInput"
            @click="validate"
            @change="onFileChange" />
          <a
            v-if="fileAttached"
            class="fillin fileupload-input-text no-overlay"
            :title="localBlobFileName"
            :download="localBlobFileName"
            :href="
              requestFile
                ? 'downloadfile.html?action=ViewFile&BlobFileName=' +
                  localBlobFileName.replaceAll('\\', '%5c')
                : fileLink
            ">
            {{ localBlobFileName }}
          </a>
          <span
            v-else
            class="fileupload-input-text"
            @click="onButtonClick"
            >No file attached</span
          >
          <input
            v-if="allowUpdate"
            type="button"
            class="icon-folder-open"
            aria-label="Choose file"
            @click="onButtonClick" />
          <input
            v-if="allowUpdate && fileAttached"
            type="button"
            class="icon-close"
            aria-label="Remove file"
            @click="removeFile" />
        </span>
      </div>
    </div>
    <div
      v-if="allowUpdate"
      class="fileupload-info"
      :class="error ? 'validation-error' : ''">
      <span ref="fileuploadExtensionInfo"
        >Safe extensions to upload: {{ uploadAllowedExtensions }}
      </span>
      <span ref="fileuploadSizeInfo"
        >Maximum file size allowed: {{ maxSize }} MB
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileUploadComponent',
  emits: ['change'],
  props: {
    id: String,
    name: String,
    modelValue: Blob,
    label: String,
    errorMessage: String,
    required: String,
    uploadAllowedExtensions: {
      type: String,
      default: 'bmp,csv,doc,docx,jpg,pdf,png,rtf,txt,xls,xlsx,heic'
    },
    maxSize: {
      type: Number,
      default: 50
    },
    allowUpdate: {
      type: Boolean,
      default: false
    },
    blobFileName: {
      type: String,
      default: ''
    },
    thumbImage: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      error: false,
      file: null,
      fileAttached: false,
      localBlobFileName: this.blobFileName,
      localThumbImage: this.thumbImage,
      requestFile: false,
      wasDeleted: false
    }
  },
  created() {
    if (this.blobFileName) {
      this.fileAttached = true
      this.requestFile = true
    }
  },
  watch: {
    modelValue() {
      if (this.file !== this.modelValue) {
        this.file = this.modelValue
      }
    }
  },
  methods: {
    onButtonClick() {
      if (this.allowUpdate) {
        this.$refs.fileInput.click()
      }
    },

    onImageClick() {
      var URL = this.fileLink != null ? this.fileLink : null
      var title = this.localBlobFileName

      if (URL === null) {
        $.ajax({
          type: 'GET',
          data:
            'Action=GetImage&BlobVersion=compress&BlobFileName=' +
            this.localBlobFileName.replaceAll('\\', '%5c'),
          cache: false,
          dataType: 'json',
          timeout: 0,
          async: false,
          success: function (xhrdata) {
            if (xhrdata) {
              URL = xhrdata.thumbImage
            }
          },
          error: 'Unable to load image file'
        })
      }

      if (URL) {
        // Add resize event in case screen size changes
        if (!this.__resizeEvent) {
          $(window).on('resize', function () {
            var $dialog = $('#imagedialog')
            if ($dialog.length > 0) {
              $dialog.dialog('option', {
                width:
                  $(window).width() > 1000 ? 1000 : $(window).width() * 0.9,
                maxWidth: $(window).width() * 0.9
              })
            }
          })
        }

        var $imageDialog = $(
          '<div id="imagedialog">' +
            '<img class="imagedialog-image" src="' +
            URL +
            '" >' +
            '</div>'
        ).appendTo($('body'))

        $imageDialog.dialog({
          title: title,
          resizable: false,
          draggable: false,
          modal: true,
          width: $(window).width() > 830 ? 830 : $(window).width() * 0.9,
          maxWidth: $(window).width() * 0.9,
          height: 800,
          close: function () {
            $(this).dialog('destroy').remove()
          }
        })

        return false
      }
    },

    validate() {
      if (this.required && (!this.file || this.localBlobFileName)) {
        this.error = true
      }
    },

    onFileChange(event) {
      const file = event.target.files[0]
      this.removeError()

      if (file) {
        this.wasDeleted = false
        if (file.size && file.size > this.maxSize * 1024 * 1024) {
          this.error = true
          this.$refs.fileuploadSizeInfo.classList.add('error-message')
        }

        if (file.name) {
          const fileExtension = file.name.replace(/^.*\./, '').toLowerCase()
          if (!this.uploadAllowedExtensions.includes(fileExtension)) {
            this.error = true
            this.$refs.fileuploadExtensionInfo.classList.add('error-message')
          }
        }
      } else {
        if (this.required && !this.localBlobFileName) {
          this.error = true
        }
      }

      if (this.error) {
        this.$refs.fileInput.value = null
        this.file = null
        this.localBlobFileName = null
        this.fileLink = null
        this.fileAttached = false
        this.localThumbImage = null
        this.$emit('change', null)

        if (this.objectURL) {
          // revoke the old object url to avoid using more memory than needed
          URL.revokeObjectURL(this.objectURL)
        }
        return
      }

      if (this.objectURL) {
        // revoke the old object url to avoid using more memory than needed
        URL.revokeObjectURL(this.objectURL)
      }

      if (file) {
        this.file = file
        this.objectURL = URL.createObjectURL(file)
        this.localBlobFileName = file.name // this name is used when the user downloads the file
        this.fileLink = this.objectURL
        this.fileAttached = true

        if (file.name) {
          const fileExtension = file.name.replace(/^.*\./, '').toLowerCase()
          const imageExtensions = 'bmp,jpg,png'
          if (imageExtensions.includes(fileExtension)) {
            this.localThumbImage = this.fileLink
          }
        }

        this.$emit('change', file)
      }
    },

    removeFile() {
      this.removeError()

      if (!this.allowUpdate) return

      if (this.objectURL) {
        // revoke the old object url to avoid using more memory than needed
        URL.revokeObjectURL(this.objectURL)
      }

      this.file = null
      this.localBlobFileName = ''
      this.fileLink = null
      this.fileAttached = false
      this.localThumbImage = null
      this.$refs.fileInput.value = null
      this.wasDeleted = true
      this.requestFile = false

      this.validate()

      this.$emit('change', null)
    },

    removeError() {
      this.error = false
      this.$refs.fileuploadSizeInfo.classList.remove('error-message')
      this.$refs.fileuploadExtensionInfo.classList.remove('error-message')
    }
  }
}
</script>

<style lang="less">
@import '../assets/css/abstract/variables.less';
@import '../assets/css/abstract/mixins.less';

.fileupload-link {
  @media @tablet-down {
    width: 100%;
    display: block;
  }
}

.fileupload-input-text {
  @media @tablet-down {
    width: auto !important;
    max-width: calc(100% - 70px);
    white-space: nowrap;
  }
}

.fileupload-image-button {
  .default-focus-indicator(4px, @primary-color);
  border-radius: 2px;
}
</style>
